import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFirm } from './firmSlicer';

export interface FirmListState {
  firmList: IFirm[];
}

const initialState: FirmListState = {
  firmList: []
};

export const firmListSlice = createSlice({
  name: 'firmList',
  initialState,
  reducers: {
    setCurrentFirmList: (state, action: PayloadAction<IFirm[]>) => {
      state.firmList = action.payload;
    },
    resetFirmList: (state) => {
      state.firmList = [];
    }
  }
});

// Action creators are generated for each case reducer function
export const { setCurrentFirmList, resetFirmList } = firmListSlice.actions;

export default firmListSlice.reducer;
